export const MENU_EDI_TYPE={
    "menu_id": "menu_edi_type",
    "menu_label": "EDI Type"
}
export const MENU_ISA={
    "menu_id": "menu_isa",
    "menu_label": "ISA Qualifier / ID"
}
export const MENU_GS={
    "menu_id": "menu_gs",
    "menu_label": "GS ID"
}